import React, { ChangeEvent } from 'react';

export const Checkbox = ({
  options,
  action,
  checked,
  label,
  name,
  type = 'checkbox',
  color = '',
  colorCustom = '',
  text = '',
  disabled = false,
  optionLabel = 'name',
  optionValue = 'id',
  optionRight = [],
  textRight = '',
  actionWrapper = false,
  required,
}) => {
  let require = [];
  if (required){
    require = Object.keys(required);
  }

  const veryfiCheck = (e) => {
    if (checked && typeof checked === 'object' ) {
      const verify = checked.filter((elem) => {
        return elem[optionValue] === e[optionValue] ? elem : null;
      });
  
      const res = checked.filter((elem) => {
        return elem[optionValue] !== e[optionValue] ? elem : null;
      });
      
      if (checked.length === 0) {
        return [e];
      } else {
        if (verify.length === 0) {
          return checked.concat(e);
        } else {
          return res;
        }
      }
    }
    return [e]
  };

  const checkedAction = (e) => {
    if (e !== undefined) {
      const resp = options ? (e ? veryfiCheck(e) : []) : e;
      const fullResponse = {name: name, value: resp, type: type, pattern: required?.pattern?required.pattern:''}
      !disabled && action && action(fullResponse, e);
    }
  };

  const veryfiChecked = (e) => {
    if (!options) {
      return checked[optionValue] === e[optionValue] ? true : false;
    } else if (typeof checked === 'object') {
      if (checked.length === 0) {
        return false;
      } else {
        const verify = checked.filter((elem) => {
          return elem[optionValue] === e[optionValue] ? elem : null;
        });

        if (verify.length === 0) {
          return false;
        } else {
          return (verify[0] && verify[0][optionValue]) === e[optionValue]
            ? true
            : false;
        }
      }
    }
  };

  return (
    <div
      className={`form-box form-checkbox ${type} ${color} ${
        disabled ? 'disabled' : ''
      } ${ required && (required.erro[name] ? 'erro' : '') }`}
    >
      {label ? <label htmlFor={`id-${name}`}>{label}</label> : null}
      {options ? (
        options.map((c, index) => {
          return (
            <div key={`checkbox-${name}-${index}`} className={`${name}-wrapper ${veryfiChecked(c) ? 'wrapper-checked' : ''}`} onClick={() => actionWrapper ? checkedAction(!disabled ? c : null) : null}>
              <div
                key={`${name}-${c[optionValue]}`}
                className={`check-box ${veryfiChecked(c) ? 'checked' : ''}`}
                onClick={() => checkedAction(!disabled ? c : null)}
              >
                <span
                  className={type}
                  style={
                    veryfiChecked(c) && (colorCustom || c.color)
                      ? {
                          backgroundColor: colorCustom
                            ? colorCustom
                            : c.color,
                        }
                      : {}
                  }
                ></span>
                <div>{c[optionLabel]}</div>                
              </div>
              {c.right ? optionRight : null} {c.textRight ? textRight : null}
            </div>
          );
        })
      ) : (
        <div
          className={`check-box ${checked ? 'checked' : ''}`}
          onClick={() => checkedAction(!disabled ? !checked : false)}
        >
          <span
            className={type}
            style={
              checked && colorCustom ? { backgroundColor: colorCustom } : {}
            }
          ></span>
          <div>{text}</div>
        </div>
      )}
    </div>
  );
};
